import { TapsReportController } from './taps-report.controller';
import * as TapsReportRoutes from './taps-report.routes';
import { IControllerConstructor } from 'angular';

/**
 * The entry point the taps report module
 */
export const initialise = () => {

  angular.module('app.taps-report', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components',
    
  ]).controller('tapsReportController', <IControllerConstructor>TapsReportController);

  TapsReportRoutes.initialise();
};